/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KPIControlModel { 
    kpiTitle?: string | null;
    valueLabel?: string | null;
    value?: number;
    readonly valueDisplay?: string | null;
    valueBackgroundColor?: string | null;
    valueForegroundColor?: string | null;
    targetLabel?: string | null;
    targetValue?: number;
    readonly targetValueDisplay?: string | null;
    targetBackgroundColor?: string | null;
    targetForegroundColor?: string | null;
    percentageLabel?: string | null;
    percentage?: number;
    readonly percentageDisplay?: string | null;
    alertBackgroundColor?: string | null;
}

